import React from "react";
import CustomGoogleTracker from "@openstack_dev/gatsby-theme-marketing-oif-core/src/components/Tracking/custom-google-tracker";
import Seo from "@openstack_dev/gatsby-theme-marketing-oif-core/src/components/Seo";
import Layout from "../components/Layout";
import Diagram from "../components/Diagram";
import OsfSection from "../components/OsfSection";
import LatestRelease from "../components/LatestRelease";
import Spotlight from "../components/Spotlight";
import UserStories from "../components/UserStories";

function IndexPage() {
  return (
    <Layout>
      <Diagram />
      <LatestRelease />
      <Spotlight />
      <UserStories />
      <OsfSection />
    </Layout>
  );
}

export default IndexPage;

export function Head({ location }) {
  return (
    <>
      <Seo location={location} />
      <CustomGoogleTracker />
    </>
  );
}
